// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./AppBundle/Resources/assets/scss/assets.scss
// module id = 311
// module chunks = 0